











































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import moment from "vue-moment";
import _ from "lodash";
import expandRow from "./view-caselabel-serials-expand.vue";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import PageRequest from "@/store/entities/page-request";

class PageCaseLabelSerialRequest extends PageRequest {
  productLocationId: Number;
  caseLabelCode: String;
  productId: Number;
}

@Component
export default class ViewCaseLabelSerials extends mixins(ListMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) productName: String;
  @Prop({ type: String, default: "" }) caseLabel: String;
  @Prop({ type: Number, default: 0 }) productLocationId: Number;
  @Prop({ type: Number, default: 0 }) productId: Number;
  @Prop({ type: Number, default: 0 }) qty: Number;
  namespace = "location";
  pagerequest: PageCaseLabelSerialRequest = new PageCaseLabelSerialRequest();
  spinShow: boolean = false;
  title: string = "";
  caseSerials = [];
  get store() {
    return this.$store.state.location;
  }
  cancel() {
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      await this.getpage();
    }
  }
  async getpage() {
    if (Util.isNull(this.productLocationId) || this.productLocationId <= 0)
      return;
    this.spinShow = true;
    this.pagerequest.productLocationId = this.productLocationId;
    this.pagerequest.caseLabelCode = this.caseLabel;
    this.pagerequest.productId = this.productId;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "location/getLocationProductOrCaseLabelSerials",
        data: this.pagerequest,
      })
      .then((res) => {
        this.title = Util.L("SerialNosDetail") + " - " + res.locationCode;
        this.caseSerials = res.items;
        this.spinShow = false;
      })
      .catch(() => {
        this.spinShow = false;
      });
  }
  created() {}
  columns = [
    {
      type: "expand",
      width: 50,
      render: (h, params) => {
        return h(expandRow, {
          props: {
            row: params.row,
          },
        });
      },
    },
    {
      title: Util.L("CaseLabelCode"),
      key: "caseLabelCode",
    },
    {
      title: Util.L("Qty"),
      key: "qty",
      align: "right",
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.qty));
      },
    },
  ];
}
